import type { Vehicle } from '@features/vehiclesearch/types/vinvrmsearch.types';
import type { VehicleDerivative } from '@features/vehiclesearch/types/manualsearch.types';

export interface VehicleParams {
    make_id?: string;
    model_id?: string;
    derivative_id?: string;
}

// Extract vehicle derivative IDs for API call
export function resolveVehicleParams(
    selectedVehicle: Vehicle | VehicleDerivative | null | undefined
): VehicleParams {
    if (!selectedVehicle) {
        return {};
    }

    // Check if it's a Vehicle with derivative or a VehicleDerivative
    const derivative =
        'derivative' in selectedVehicle && selectedVehicle.derivative
            ? selectedVehicle.derivative
            : selectedVehicle;

    if ('make' in derivative && 'model' in derivative) {
        return {
            make_id: derivative.make?.id ?? undefined,
            model_id: derivative.model?.id ?? undefined,
            derivative_id: derivative.id ?? undefined,
        };
    }

    return {};
}
